<template>
    <div class="table-responsive p-0">
        <slot name="header"></slot> 
        <table class="table table-bordered table-centered mb-0 w-100 dt-responsive nowrap no-footer dtr-inline collapsed">            
            <!-- <thead class="table-light">
                <tr class="border success item-head">
                    <th v-for="column in columns" :key="column.name"
                        @click="sort(column.name, sortable)"  
                        :style="'width:'+column.width+';'+'cursor:pointer; height: 42px;'">
                        {{ column.label }} 
                        <img v-if="!column.isAction" :src="sortKey === column.name ? (iconSortPath ? iconSortPath : iconSortBothPath) : iconSortBothPath" >
                    </th>
                </tr>
            </thead> -->
            <thead class="table-light">

                <!-- ROW 1 -->
                <tr class="border success item-head">
                    <template v-for="column in columns" :key="column.name || column.label">

                    <!-- GROUP HEADER -->
                    <th v-if="column.children"
                        :colspan="column.children.length"
                        :style="'text-align:center; height:42px;'">
                        {{ column.label }}
                    </th>

                    <!-- NORMAL HEADER -->
                    <th v-else
                        :rowspan="hasGroupedColumns ? 2 : 1"
                        @click="sort(column.name, sortable)"
                        :style="'width:'+column.width+';cursor:pointer;height:42px;'">

                        {{ column.label }}

                        <img v-if="!column.isAction"
                            :src="sortKey === column.name
                                ? (iconSortPath ? iconSortPath : iconSortBothPath)
                                : iconSortBothPath">
                    </th>

                    </template>
                </tr>

                <!-- ROW 2 (only if grouped exists) -->
                <tr v-if="hasGroupedColumns" class="border success item-head">
                    <template v-for="column in columns">

                    <template v-if="column.children">
                        <th v-for="child in column.children"
                            :key="child.name"
                            @click="sort(child.name, sortable)"
                            style="cursor:pointer;height:42px;">

                        {{ child.label }}

                        <img v-if="!child.isAction"
                            :src="sortKey === child.name
                                ? (iconSortPath ? iconSortPath : iconSortBothPath)
                                : iconSortBothPath">
                        </th>
                    </template>

                    </template>
                </tr>

                </thead>


            <slot name="body"></slot> 
        </table>
        <slot name="footer"></slot>
    </div>
</template>

<script>
import { computed } from 'vue';
import imgSortAsc from '../assets/images/sort_asc.png';
import imgSortDesc from '../assets/images/sort_desc.png';
import imgSortBoth from '../assets/images/sort_both.png';
    export default {
        props: ['columns', 'sortKey'],
        data() {
            return { 
                iconSortPath: imgSortDesc,
                sortable: 'ASC' , 
                iconSortBothPath: imgSortBoth, 
            }
        },
        emits:['sort'],
        methods: {
            sort(column, sortable){  
                if(column){
                    this.$emit('sort', column, sortable);                     
                    if(sortable =='ASC'){
                        this.iconSortPath = imgSortAsc;
                        this.sortable = 'DESC';
                    }  else {
                        this.iconSortPath = imgSortDesc;
                        this.sortable = 'ASC';
                    } 
                }
            } 
        },
        created() {  
        },

        computed: {
            hasGroupedColumns() {
                return this.columns.some(column => column.children && column.children.length > 0);
            }
        }
    }

</script>